import { LOCALES } from 'src/constants/main';

export type TLocale = LOCALES.EN | LOCALES.AR;

export interface IPagination<T> {
  data: T[];
  current_page: number;
  last_page: number;
  per_page: number;
  from: number | null;
  to: number | null;
  total: number;
  // url's
  path: string;
  first_page_url: string;
  last_page_url: string;
  next_page_url: string | null;
  prev_page_url: string | null;
  // frontend params
  pages?: number[];
  loading?: boolean;
  refreshing?: boolean;
  //
  avg_spending?: number;
}

export interface IResponse<T> {
  result: boolean;
  message: string | null;
  data: T | null;
}

export interface IPaginationLight {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface IErrorOption {
  text: string;
  background?: string;
  color?: string;
  onPress?: () => void;
}

export interface IError {
  title?: string;
  message?: string;
  options: IErrorOption[];
}

export type TBooleanInNumber = 1 | 0;
export type TExternalId = null | string | number;
export type TTranslate = {
  [key: string]: string;
};

export type TCRUDEvents = 'created' | 'updated' | 'deleted';

export type LatLng = {
  lat: number;
  lng: number;
};

export type CoordsPaths = LatLng[];
export type CoordsBounds = [LatLng['lat'], LatLng['lng']][];

export interface IValidation {
  isValid: boolean;
  errorText?: string | null;
}

export interface ILangTextValidation {
  enValid: boolean;
  enErrorText?: string;
  arValid: boolean;
  arErrorText?: string;
}

export interface IPriceValidation {
  state: boolean;
  errorText?: string;
}

export interface ICaloriesValidation {
  state: boolean;
  errorText?: string;
}

export enum MODALS_CRUMB {
  ALL,
  SELECTED,
}

export interface ICountsResponce {
  available: number;
  deleted: number;
  donatable?: number;
  donatableItems?: TTranslate[];
}

export enum LoadingStatus {
  Init = 'INIT',
  Loading = 'LOADING',
  Refreshing = 'REFRESHING',
  Success = 'SUCCESS',
  Aborted = 'ABORTED',
  Error = 'ERROR',
}

export const paginationCast = (data: any) => ({
  currentPage: Number(data.current_page),
  lastPage: Number(data.last_page),
  perPage: Number(data.per_page),
  totalRows: Number(data.total),
});

export type TPagination = ReturnType<typeof paginationCast>;
